import React from "react";
import { Modal } from "antd";
import { PartHistoryList } from "./PartHistoryList";

// Read-only floating reference panel for the New Query form — non-blocking
// (mask={false}, centered) so the agent can keep editing the form on the
// left and using chat on the right while it's up. One section per part
// that has at least one match; a part with none is simply omitted from
// `partsWithHistory` by the caller, not rendered empty here.
//
// maskClosable={false}: antd still keeps an invisible click-catching mask
// even with mask={false} (only the dimming is hidden), so without this the
// panel would silently close on any click outside it — stay open until the
// agent dismisses it deliberately.
export function PartHistoryModal({ open, onClose, partsWithHistory = [] }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      mask={false}
      maskClosable={false}
      centered
      width={540}
      title="Supplier price history"
    >
      <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 12 }}>
        Reference only — safe to close. The same history is also shown per-part in Manage Price once this query is created.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 14, maxHeight: "60vh", overflowY: "auto" }}>
        {partsWithHistory.map(p => (
          <div key={p.key}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>{p.label}</div>
            <PartHistoryList matches={p.matches} />
          </div>
        ))}
      </div>
    </Modal>
  );
}
